import dayjs from 'dayjs';
import { IConsigne } from './consigne.interface';

export class Consigne implements IConsigne {
  constructor(
    public id: string,
    public debut: dayjs.Dayjs,
    public fin?: dayjs.Dayjs,
    public text?: string,
    public lien?: string
  ) {}

  public static hydrate(consigne: Consigne): Consigne {
    return new Consigne(consigne.id, dayjs(consigne.debut), consigne.fin ? dayjs(consigne.fin) : undefined, consigne.text, consigne.lien);
  }
}
